import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';
import { collection, query, where, getDocs, orderBy, limit, startAfter, getCountFromServer } from 'firebase/firestore';

import './journal.css';

function JournalArticle() {
  // State management
  const [journalArticles, setJournalArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Journal Articles from Firestore -
  const fetchArticles = async (page) => {
    try {
      const pageSize = 6; // Number of items per page
      const articleRef = collection(db, 'mainresources');
      let q = query(
        articleRef,
        where('resourceType', '==', 'Journal Article'),
        orderBy('created_at'),
        limit(pageSize)
      );

      if (page > 1 && lastVisible) {
        q = query(
          articleRef,
          where('resourceType', '==', 'Journal Article'),
          orderBy('created_at'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);
      const articles = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setJournalArticles(articles);
      setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);

      // Calculate total pages using count query
      const countSnapshot = await getCountFromServer(query(articleRef, where('resourceType', '==', 'Journal Article')));
      const totalPages = Math.ceil(countSnapshot.data().count / pageSize);
      setTotalPages(totalPages);

    } catch (error) {
      console.error("Error fetching journal articles:", error);
    }
  };

  // Handle pagination click
  const paginate = (page) => {
    setCurrentPage(page);
    fetchArticles(page);
  };

  useEffect(() => {
    fetchArticles(currentPage);
  }, [currentPage]);

  return (
  <div className="journal-page-container">

    {/* HERO SECTION */}
    <section className="hero">

      <div className="hero-image">
        <img
          src="/imgbook.png"
          alt="Research Articles"
        />
      </div>

      <div className="hero-content">

        <h1>Eye Care Digital Library</h1>

        <p>
          Discover peer-reviewed ophthalmology
          articles, vision science publications,
          academic journals, research findings,
          and professional eye care resources.
        </p>

      </div>

    </section>

    {/* PAGE HEADER */}
    <div className="journal-heading-section">

      <h2>Research Articles</h2>

      <p>
        Access a comprehensive collection of
        ophthalmic journal articles and academic
        publications covering clinical studies,
        eye diseases, diagnostic innovations,
        treatment methods, and modern vision
        science research.
      </p>

    </div>

    {/* ARTICLES GRID */}
    <div className="articles-container">

      {journalArticles.length > 0 ? (

        journalArticles.map((article) => (

          <div
            key={article.id}
            className="article-item"
          >

            {/* COVER IMAGE */}
            {article.coverImageURL && (
              <img
                src={article.coverImageURL}
                alt={article.title}
                className="book-cover-image"
              />
            )}

            {/* CONTENT */}
            <div className="article-content">

              {/* TITLE */}
              <h4>{article.title}</h4>

              {/* META DATA */}
              <div className="book-meta-data">

                {article.author && (
                  <p>
                    <strong>Author:</strong>{" "}
                    {article.author}
                  </p>
                )}

                {article.publication_year && (
                  <p>
                    <strong>Year:</strong>{" "}
                    {article.publication_year}
                  </p>
                )}

                {article.isbn && (
                  <p>
                    <strong>ISBN:</strong>{" "}
                    {article.isbn}
                  </p>
                )}

              </div>

              {/* DESCRIPTION */}
              {article.description && (
                <p className="book-description">
                  {article.description}
                </p>
              )}

              {/* BUTTON */}
              {article.pdfFileURL && (
                <a
                  href={article.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read Article
                </a>
              )}

            </div>

          </div>

        ))

      ) : (

        <div className="no-books-found">

          <h3>No Articles Available</h3>

          <p>
            No ophthalmology journal articles or
            research publications have been
            uploaded yet.
          </p>

        </div>

      )}

    </div>

    {/* PAGINATION */}
    {totalPages > 1 && (

      <div className="pagination-container">

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage - 1)
          }
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {Array.from(
          { length: totalPages },
          (_, index) => (

            <button
              key={index + 1}
              className={`pagination-button ${
                currentPage === index + 1
                  ? 'active'
                  : ''
              }`}
              onClick={() =>
                paginate(index + 1)
              }
            >
              {index + 1}
            </button>

          )
        )}

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage + 1)
          }
          disabled={
            currentPage === totalPages
          }
        >
          Next
        </button>

      </div>

    )}

  </div>
);
}

export default JournalArticle;
